import Link from "next/link";
import { connect } from "react-redux";

import ModalErrorBoundary from "@containers/ModalErrorBoundary";
import LoginModal from "@components/LoginModal";
import { addModal } from "@store/app/actions";
import RegisterModal from "@components/RegisterModal";
import ResetPassModal from "@components/ResetPassModal";

const loginModalId = "login-modal-credex-cashback";
const registerModalId = "register-modal-credex-cashback";
const resetPassModalId = "reset-pass-modal-credex-cashback";

const CredexCashbackBanner = ({ credexCashback, isLoggedIn, addModal }) => {
  const { label, link, enabled } = credexCashback || {};

  if (!enabled) {
    return null;
  }

  return (
    <div className="flex gap-[16px] items-center justify-between bg-[#EEEAFF] py-[12px] px-[16px] border border-[#DBCDEE] rounded font-medium text-[#7E5E9C]">
      {label && <span dangerouslySetInnerHTML={{ __html: label }} />}

      {isLoggedIn ? (
        <Link href={link}>
          <a
            className="px-[16px] py-[8px] bg-white rounded-full text-[#7E5E9C] content-center max-h-fit"
            title="aplica pentru card de credit credex"
          >
            Aplica
          </a>
        </Link>
      ) : (
        <button
          className="px-[16px] py-[8px] bg-white rounded-full text-[#7E5E9C] content-center max-h-fit"
          title="aplica pentru card de credit credex"
          onClick={() => addModal(loginModalId)}
        >
          Aplica
        </button>
      )}

      <ModalErrorBoundary>
        <LoginModal
          location="pop-up-credex-cashback"
          modalId={loginModalId}
          registerModalId={registerModalId}
          resetPassModalId={resetPassModalId}
          redirect={link}
        />
      </ModalErrorBoundary>

      <ModalErrorBoundary>
        <RegisterModal modalId={registerModalId} loginModalId={loginModalId} />
      </ModalErrorBoundary>

      <ModalErrorBoundary>
        <ResetPassModal modalId={resetPassModalId} />
      </ModalErrorBoundary>
    </div>
  );
};

export default connect(
  (state) => ({
    isLoggedIn: state.user.isLoggedIn,
    credexCashback: state.credex.data?.cashbackBanner,
  }),
  { addModal }
)(CredexCashbackBanner);
